import { createEvent, createStore } from 'effector';
import { type PayoutCascadeTemplateFilters } from '~/entities/payout';
import { createPagination } from '~/shared/lib/pagination';

export const paginationModel = createPagination();

export const setCascadeTemplatesFilter = createEvent<PayoutCascadeTemplateFilters>();
export const $cascadeTemplatesFilter = createStore<PayoutCascadeTemplateFilters>({}).on(
    setCascadeTemplatesFilter,
    (state, payload) => ({
        ...state,
        ...payload,
    }),
);
